import { useAuth } from '@soap/modules';
import { useMemo } from 'react';

export function useUserRole() {
  const { accessToken } = useAuth('useUserRole');

  const { userRoles, userId } = useMemo(() => {
    if (!accessToken) return { userRoles: [], userId: null };

    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      const roles = payload["https://soap.idaam/roles"] || [];
      const uid = payload.sub ?? null;
      return { userRoles: roles, userId: uid };
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return { userRoles: [], userId: null };
    }
  }, [accessToken]);

  const permissions = useMemo(() => {
    if (!accessToken) return [];

    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      return payload.permissions || [];
    } catch (error) {
      return [];
    }
  }, [accessToken]);

  const isStudent = useMemo(() => {
    return userRoles.some(x => x.endsWith(':student'));
  }, [userRoles]);

  const isOrgAdmin = useMemo(() => {
    return userRoles.some(x => x.endsWith(':org-admin'));
  }, [userRoles]);

  const isTeacher = useMemo(() => {
    return userRoles.some(x => x.endsWith(':teacher'));
  }, [userRoles]);

  const isOrgUser = useMemo(() => {
    return userRoles.some(x => x.endsWith(':org-user'));
  }, [userRoles]);

  const isTutor = useMemo(() => {
    return userRoles.some(x => x.endsWith(':tutor'));
  }, [userRoles]);

  const hasDeveloperOptionsPermission = useMemo(() => {
    const check = (x) => typeof x === 'string' && x.endsWith('::atestme:builtin:developer-options/execute');
    return permissions.some(check) || userRoles.some(check);
  }, [permissions, userRoles]);

  return {
    userRoles,
    userId,
    isStudent,
    requestingUserIsOrgAdmin: isOrgAdmin,
    isTeacher,
    isOrgUser,
    isTutor,
    hasDeveloperOptionsPermission
  };
}
